import { createElement } from "@wordpress/element";

function PanelHeader(_ref) {
  let {
    label,
    children
  } = _ref;
  return createElement("div", {
    className: "components-panel__header"
  }, label && createElement("h2", null, label), children);
}

export default PanelHeader;
//# sourceMappingURL=header.js.map